import { useCallback } from "react";

import { NavPortal, SearchFilter } from "components";
import { setManufacturerDashboardFilters, useManufacturerDashboardFilters } from "modules/ManufacturerDashboard/hooks";

export const ManufacturerSearch = () => {
  const filters = useManufacturerDashboardFilters();

  const handleSearchChange = useCallback(
    (input: string) => {
      setManufacturerDashboardFilters({ ...filters, search_term: input ? input : null });
    },
    [filters]
  );

  return (
    <NavPortal>
      <SearchFilter value={filters.search_term || ""} handleSearchChange={handleSearchChange} />
    </NavPortal>
  );
};
